import { PropTypes } from 'react-desc';
import { MASK_TYPES } from '@elliemae/ds-form/InputMask';

var zipcodeSearchProps = {
  /** html class attribute */
  className: PropTypes.string.description('html class attribute'),

  /** Set of Properties attached to the main container */
  containerProps: PropTypes.object.description('Set of Properties attached to the main container'),

  /** native tabindex property to handle focus order */
  tabIndex: PropTypes.number.description('native tabindex property to handle focus order'),

  /** disable component */
  disabled: PropTypes.bool.description('disable component'),

  /** input value */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).description('input value').isRequired,

  /** function called on blur */
  onBlur: PropTypes.func.description('function called on blur'),

  /** function called on change */
  onChange: PropTypes.func.description('function called on change'),

  /** options to display */
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })).description('options to display'),

  /** placeholder value */
  placeholder: PropTypes.string.description('placeholder value'),

  /** format mask to apply */
  mask: PropTypes.arrayOf(PropTypes.any).description('format mask to apply'),

  /** function called onsearch */
  onSearch: PropTypes.func.description('function called onsearch'),

  /** Correction messange */
  selectRightOptions: PropTypes.string.description('Correction messange'),

  /** current amount */
  activeCount: PropTypes.number.description('current amount')
};
var defaultProps = {
  disabled: false,
  value: '',
  placeholder: '_____-____',
  mask: MASK_TYPES.ZIP_CODE_SEARCH,
  onBlur: function onBlur() {
    return null;
  },
  onChange: function onChange() {
    return null;
  },
  onSearch: function onSearch() {
    return null;
  },
  containerProps: {},
  selectRightOptions: 'Please select the appropriate city',
  activeCount: 5,
  options: []
};

export { defaultProps, zipcodeSearchProps };
//# sourceMappingURL=props.js.map
